// Replace this with your actual API endpoint

 /* const apiUrl = "https://your-server.com/api/customer-data"; */


// You can get url_string from window.location.href if you want to work with
// the URL of the current page
var url_string = window.location.href; 
/////////// alert('url_string = ' + url_string);
var url = new URL(url_string);
var pid = url.searchParams.get("pid");
//////// alert('pid = ' + pid);

 const apiUrl2 = "https://app.vetmeds.ca/adminview.php";

// Get the customer ID from Shopify Liquid variables
const shopifyCustomerId2 = pid; // This will be rendered by Shopify Liquid

fetch(`${apiUrl2}?pet_id=${shopifyCustomerId2}`)
  .then((response) => response.json())
  .then((data) => {
    console.log("API Response:", data);

    if (Array.isArray(data)) {
      const detailsContainer = document.getElementById("pet-details");
    
       var tableHTML = '';
      if (detailsContainer) {
     for (let i = 0; i < data.length; i++) {
        tableHTML = '<table class="view-tab"><tbody><tr><td>Name*</td><td align="left">' + data[i].pet_name + '</td></tr><tr><td>Type*</td><td align="left">' + data[i].pettype + '</td></tr><tr><td>Gender*</td><td align="left">' + data[i].petgender + '</td></tr><tr><td>Breed*</td><td align="left">' + data[i].pet_breed + '</td></tr><tr><td>Birth Date*</td><td align="left">' + data[i].petbirthdate + '</td></tr><tr><td>Color*</td><td align="left">' + data[i].pet_color +'</td></tr><tr><td>Weight*</td><td align="left">' + data[i].weight + '</td></tr><tr><td>Weight Unit*</td><td align="left">' + data[i].petweightunit + '</td></tr><tr><td>Medical Conditions*</td><td align="left">' + data[i].medicalconditions + '</td></tr><tr><td>Allergies (Drug &amp; Medical)*</td><td align="left">' + data[i].moredeailsallergies + '</td></tr><tr><td>Medications from other Pharmacy*</td><td align="left">' + data[i].medications_other_pharmacy + '</td></tr><tr><td>Current non-prescription, herbal products &amp; Vitamins</td><td align="left">' + data[i].current_nonprescription_details + '</td></tr><tr><td>More Details</td><td align="left">' + data[i].moredetails + '</td></tr><tr><td><h4>Veterinarian Info</h4></td><td align="left">&nbsp;</td><tr><td>Doctor Name*</td><td align="left">' + data[i].doctor_name + '</td></tr><tr><td>Practice Name*</td><td align="left">' + data[i].practice_name + '</td></tr><tr><td>Phone*</td><td align="left">' + data[i].doctor_phone + '</td></tr><tr><td>Fax</td><td align="left">' + data[i].doc_fax + '</td></tr><tr><td>Address*</td><td align="left">' + data[i].doc_address + '</td></tr></tbody></table>';
 }
        detailsContainer.innerHTML =  tableHTML; 
        

        
      }
    } else {
      console.warn("Expected an array but got:", data);
    }
  })
  .catch((error) => {
    console.error("Error fetching customer data:", error);
  });